import { CopyButton } from 'ui'

const CopyableSpan = ({ text, tone }) => <CopyButton copyLabel="Copy License Key" text={text} tone={tone}>{text}</CopyButton>

export default CopyableSpan
